import React from "react";

export const VideoIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8075 10.12C14.3855 9.77993 14.3855 8.94392 13.8075 8.60387L4.08438 2.88441C3.49809 2.53953 2.75898 2.96226 2.75898 3.64247L2.75898 15.0814C2.75898 15.7616 3.49809 16.1843 4.08438 15.8394L13.8075 10.12ZM14.6993 7.08774C16.4336 8.10791 16.4336 10.6159 14.6993 11.6361L4.97622 17.3556C3.21733 18.3902 1 17.122 1 15.0814L1 3.64247C1 1.60184 3.21733 0.333645 4.97622 1.36829L14.6993 7.08774Z"
    />
  </svg>
);
